import React from "react";
import { Helmet } from "react-helmet-async";

import AIReadinessSurveyMain from "../includes/AIReadinessSurvey/AIReadinessSurvey";

const AIReadinessSurvey = () => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.exddigital.com/ai-readiness-survey",
    },
    headline: "AI Readiness Survey — Is Your Organization Ready for AI?",
    description:
      "Take ExD Digital's free AI Readiness Assessment. Answer 22–24 questions and receive a personalized AI Readiness Report for your business.",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>AI Readiness Survey</title>
        <meta
          name="description"
          content="Take ExD Digital's free AI Readiness Assessment. Answer 22–24 questions and receive a personalized AI Readiness Report for your business."
        />
        <link
          rel="canonical"
          href="https://www.exddigital.com/ai-readiness-survey"
        />

        <meta
          property="og:title"
          content="AI Readiness Survey | ExD Digital"
        />
        <meta
          property="og:description"
          content="Take ExD Digital's free AI Readiness Assessment. Answer 22–24 questions and receive a personalized AI Readiness Report for your business."
        />
        <meta
          property="og:url"
          content="https://www.exddigital.com/ai-readiness-survey"
        />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="AI Readiness Survey | ExD Digital"
        />
        <meta
          name="twitter:description"
          content="Take ExD Digital's free AI Readiness Assessment and get your personalized report."
        />

        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>

      <AIReadinessSurveyMain />
    </>
  );
};

export default React.memo(AIReadinessSurvey);
